const SITE_KEY = "9d4f18a2c6b073e15a8d4c90";
const SCRIPT_URL = "https://jokicstudio.de/cockpit.js?v=1";
const ENDPOINT = "https://jokicstudio.de/api/portal/analytics.php";

type CockpitApi = {
  start: () => void;
  pageview: (path?: string) => void;
};

function cockpitWindow(): Window & {
  jokicCockpit?: CockpitApi;
  __jokicCockpitScript?: boolean;
  __jokicCockpitPending?: string;
  __jokicCockpitConfig?: { siteKey: string; endpoint: string; views?: boolean };
} {
  return window;
}

export function connectCockpit(path: string): void {
  if (typeof document === "undefined") return;
  if (path.startsWith("/dashboard")) return;

  const target = cockpitWindow();
  target.__jokicCockpitPending = path;

  if (target.jokicCockpit) {
    target.jokicCockpit.pageview(path);
    return;
  }

  if (target.__jokicCockpitScript) return;

  target.__jokicCockpitScript = true;
  target.__jokicCockpitConfig = { siteKey: SITE_KEY, endpoint: ENDPOINT, views: false };
  const script = document.createElement("script");
  script.src = SCRIPT_URL;
  script.defer = true;
  script.dataset.site = SITE_KEY;
  script.dataset.endpoint = ENDPOINT;
  script.dataset.views = "off";
  script.onload = () => {
    target.jokicCockpit?.start();
    const pending = target.__jokicCockpitPending;
    if (pending && pending !== window.location.pathname) {
      target.jokicCockpit?.pageview(pending);
    }
  };
  document.head.appendChild(script);
}
